import { Component, mixins } from 'types-vue'
import CcpMixin from '../../Mixins/Ccp';
import CCPService from '../../Services/CCP'

@Component
export default class FrameContainer extends mixins(CcpMixin) {


  /**
   * STATE
   */

  protected showing: boolean = true

  

  /**
   * COMPUTEDS
   */

  get headerArrowIcon() {
    return (this.showing)
      ? 'el-icon-caret-bottom'
      : 'el-icon-caret-top'
  }



  /**
   * COMPONENTS EVENTS
   */

  onClickCloseButton() {
    this.showing = !this.showing
  }
  


  /**
   *  CONNECT EVENTS
   */

  onNewContact(contact: connect.Contact) {
    this.showing = true
  }


  
  /**
   * VUE LIFE CYCLE
   */

  mounted() {
    const container = this.$refs.ccpContainer as HTMLElement
    this.initCCP(container)
    CCPService.subscribeContact(this.onNewContact.bind(this))
    connect.contact(this.onNewContact.bind(this))
  }
}